import React, { useState } from "react";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";

function Press() {
  const [isMobile] = useState(window.innerWidth <= 768);

  return (
    <>
      <CustomerHeader />
      <div
        style={{
          padding: isMobile ? "86px 16px 30px" : "106px 32px 42px",
          background: "#f9fafb",
        }}
      >
        <div
          style={{
            maxWidth: "920px",
            margin: "0 auto",
            background: "white",
            borderRadius: "16px",
            padding: isMobile ? "24px" : "40px",
            border: "1px solid #e5e7eb",
          }}
        >
          <h1 style={{ marginTop: 0, color: "#111827" }}>Press Center</h1>
          <p style={{ color: "#4b5563", lineHeight: "1.7" }}>
            This page is for media announcements, product updates, company milestones,
            and press resources. We will publish official updates here as we grow.
          </p>

          <div
            style={{
              marginTop: "24px",
              padding: "20px",
              background: "#f3f4f6",
              borderRadius: "12px",
              color: "#374151",
            }}
          >
            Media resources and press releases are coming soon.
          </div>

          <p style={{ marginTop: "20px", color: "#6b7280" }}>
            Press inquiries: press@ogestyle.com
          </p>
        </div>
      </div>
      <CustomerFooter />
    </>
  );
}

export default Press;
